import {Component, Input} from "@angular/core";
import {UploadFormConfig} from "../upload-form-config";
import {MeasurementType} from "../../measurement-models";

@Component({
    selector: "app-form-selector",
    templateUrl: "./upload-form-selector.component.html",
    standalone: false
})
export class UploadFormSelectorComponent {

  @Input() type!: MeasurementType;
  @Input() showPostMeasurementFields = true;
  @Input() showPreMeasurementFields = true;
  @Input() ecgTechnicianAnalysisOnlyEnabled = false;
  @Input() isHome = false;
  @Input() formConfig!: UploadFormConfig;

  shouldShow(type: MeasurementType): boolean {
    return this.type === type;
  }

}
